import {
  COUNTRY_TO_AREA_UNIT_MAP,
  COUNTRY_TO_CURRENCY_CODE_MAP,
  CURRENCY_CODE_TO_SYMBOL_MAP,
} from "./i18n.consts";

/** Currency for a space's country (e.g. `"US"` -> `"USD"`) */
const getCurrencyCode = (country: string): string => {
  return COUNTRY_TO_CURRENCY_CODE_MAP[country] || "USD";
};

/** Plain currency symbol for a space's country (e.g. `"US"` -> `"$"`). */
const getCurrencySymbol = (country: string): string => {
  return CURRENCY_CODE_TO_SYMBOL_MAP[getCurrencyCode(country)] || "$";
};

/** A space's area unit field/label by country (e.g. `"US"` -> `"sqft"`). */
const getAreaUnit = (country: string): "sqft" | "sqm" => {
  return COUNTRY_TO_AREA_UNIT_MAP[country] || "sqft";
};

export { getCurrencyCode, getCurrencySymbol, getAreaUnit };
